import { render, staticRenderFns } from "./IdeaList.vue?vue&type=template&id=156f3b02&scoped=true&"
import script from "./IdeaList.vue?vue&type=script&lang=js&"
export * from "./IdeaList.vue?vue&type=script&lang=js&"
import style0 from "./IdeaList.vue?vue&type=style&index=0&id=156f3b02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156f3b02",
  null
  
)

export default component.exports